import styles from "./DashboardPage.module.scss";
import { DashboardProfessional } from "../../components/DashboardProfessional/DashboardProfessional";
import { DashboardPatient } from "../../components/DashboardPatient/DashboardPatient";
import { useAuthContext } from "../../context/AuthContext";
import { useSearchParams } from "react-router-dom";

export const DashboardPage = () => {
  const { user } = useAuthContext();
  const [searchParams] = useSearchParams();
  const isPatientView = searchParams.get('view') === 'patient';

  return (
    <div className={styles[`mainPage`]}>
      {user?.type_account === "professional" && !isPatientView ? (
        <DashboardProfessional />
      ) : (
        <DashboardPatient />
      )}
    </div>
  );
};
